// Styles
import './scss/main.scss';

// Scripts
import './scripts/main.js';

// Vendors
//Font Awesome
/* import "./scripts/vendors/fontawesome.js";
import "./scripts/vendors/solid.js";
import "./scripts/vendors/brands.js";
 */